export const nextTick = (() => {
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) {
        return (cb) => Promise.resolve().then(cb);
    }
    else {
        return (cb, setTimeoutFn) => setTimeoutFn(cb, 0);
    }
})();
export const globalThisShim = (() => {
    if (typeof self !== "undefined") {
        return self;
    }
    else if (typeof window !== "undefined") {
        return window;
    }
    else {
        return Function("return this")();
    }
})();
export const defaultBinaryType = "arraybuffer";
export function createCookieJar() { }



//////////////////
// WEBPACK FOOTER
// ./node_modules/engine.io-client/build/esm/globals.js
// module id = 183
// module chunks = 0